import { IconList } from '../../reusable';

import whatIsPsychiatryList from './what-is-psychiatry-list';
import whatWeTreatList from './what-we-treat-list';

export const WhatIsPsychiatryList = () => (
  <IconList listItems={whatIsPsychiatryList} />
);
export const WhatWeTreatList = () => <IconList listItems={whatWeTreatList} />;
